<template>
  <span
    class="breadcrumbs-child flex flex-row-reverse flex-no-wrap items-center"
  >
    <router-link
      v-if="first || second || last"
      class="breadcrumbs-child__label inline-block text-sans-xl pr-3"
      :class="[
        { 'font-semibold breadcrumbs-child__label--first col-auto': first },
        { 'breadcrumbs-child__label--last': last },
        { 'breadcrumbs-child__label--second': second },
      ]"
      :to="link"
      >{{ label }}</router-link
    >
    <span
      v-else
      class="breadcrumbs-child__label breadcrumbs-child__label--middle text-sans-xl pr-3"
      >...</span
    >

    <template v-if="folder.parent">
      <span class="breadcrumbs-child__separator inline-block w-8 h-auto pr-3">
        <ChevronRight />
      </span>
      <span class="col-1/x">
        <BreadcrumbsChild :folder="folder.parent" :second="first" />
      </span>
    </template>
  </span>
</template>

<script>
/** Icons */
import ChevronRight from '@/assets/icons/icon-chevron_right.svg'

export default {
  name: 'BreadcrumbsChild',

  components: {
    ChevronRight,
  },

  props: {
    folder: {
      type: Object,
      default: () => {},
    },

    first: {
      type: Boolean,
      default: false,
    },

    second: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    label() {
      return this.folder.name === 'root' ? 'Le mie storie' : this.folder.name
    },

    link() {
      return {
        name: 'Folders',
        params: {
          id: this.folder.parent ? this.folder._id : undefined,
          tenant: this.$route.params.tenant,
        },
      }
    },

    last() {
      return !this.folder.parent
    },
  },
}
</script>

<style lang="scss" scoped>
.breadcrumbs-child {
  @include e(label) {
    @apply whitespace-no-wrap overflow-hidden;
    text-overflow: ellipsis;

    // @include m(middle) {
    //   max-width: 100%;
    //   width: auto;
    //   flex: 0 0 auto;
    //   -ms-flex: 0 0 auto;
    // }

    // @include m(last) {
    //   max-width: 100%;
    //   width: auto;
    //   flex: 0 0 auto;
    //   -ms-flex: 0 0 auto;
    // }
  }
}
</style>
